export default {
  path: '/posts',
  component: () => import('@/layouts/PublicLayout'),
  redirect: '/posts/:id/detail',
  children: [
    {
      path: ':id/detail',
      component: () => import('@/views/posts/Detail.vue'),
      meta: {
        title: '文章详情'
      }
    },
    {
      path: ':seo_uri',
      component: () => import('@/views/posts/SeoUri.vue')
    }
  ]
}
